// extracted by mini-css-extract-plugin
export var bounce = "_ot-1";
export var generatingText = "_ot-6";
export var lightning = "_ot-4";
export var popup = "_ot-5";
export var progressBar = "_ot-7";
export var progressFill = "_ot-8";
export var progressShimmer = "_ot-9";
export var progressText = "_ot-a";
export var shimmer = "_ot-3";
export var uploadIcon = "_ot-0";
export var uploadingText = "_ot-2";